import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getIsGameStarted} from "modules/selectors";
import {
	Modal,
	ModalBackdrop,
	ModalButtons,
	ModalCloseButton,
	ModalText,
	ModalTitle,
} from "components/Common/Modal";
import {OutlinedButton, PrimaryButton} from "components/Common/Buttons";
import {IconClose, IconError} from "components";
import {usePrompt} from "modules/utils/hooks";

export const LeaveModal: React.FC = () => {
	const {t} = useTranslation();
	const isBlocking = useSelector(getIsGameStarted);
	usePrompt("If you leave now you will lose your streak.", isBlocking);

	return (
		<React.Fragment>
			<ModalBackdrop />
			<Modal>
				<ModalCloseButton>
					<IconClose />
				</ModalCloseButton>
				<IconError />
				<ModalTitle>{t("modal.leave.title")}</ModalTitle>
				<ModalText>{t("modal.leave.text")}</ModalText>
				<ModalButtons>
					<PrimaryButton>{t("modal.leave.cancel")}</PrimaryButton>
					<OutlinedButton>{t("modal.leave.leave")}</OutlinedButton>
				</ModalButtons>
			</Modal>
		</React.Fragment>
	);
};
